<template>
  <b-modal id="ingresar-liquidacion" size="lg" body-class="p-0 py-4" hide-header hide-footer @show="onShow">
    <form-wizard
      color="#0074d9"
      shape="circle"
      stepSize="xs"
      errorColor="#ff4136"
      ref="wizard"
      nextButtonText="Siguiente"
      backButtonText="Atrás"
      finishButtonText="Finalizar"
      @on-complete="onComplete"
      title=""
      subtitle=""
    >
      <tab-content title="Seleccionar embarques" :before-change="fetchShipmentBoxes">
        <b-form-group label="Embarques a liquidar">
          <v-select multiple :options="shipmentOptions" v-model="selectedShipments" :reduce="(i) => i.id"></v-select>
        </b-form-group>
      </tab-content>
      <tab-content title="Ingresar precio cajas">
        <b-table :items="boxes" :fields="fields" foot-clone fixed>
          <template #cell(price)="data">
            <b-form-input size="sm" type="number" v-model="boxes[data.index]['price']" />
          </template>
          <template #cell(subtotal)="data">
            {{ getSubtotal(data.item) | currency }}
          </template>
          <template #foot()> <span></span> </template>
          <template #foot(subtotal)>{{ getTotal | currency }}</template>
        </b-table>
        <p class="text-right">
          Total cajas: <b>{{ boxes.reduce((acc, item) => acc + parseFloat(item.total), 0) }}</b> <br />
          Total kilos: <b>{{ getNetKilograms | decimal }}</b>
        </p>
      </tab-content>
      <tab-content title="Ingresar liquidacion">
        <b-row>
          <b-col>
            <b-form-group label="Date">
              <b-form-input v-model="form.date" type="date"></b-form-input>
            </b-form-group>

            <b-form-group label="Commission">
              <b-form-input v-model="form.commision" type="number"></b-form-input>
            </b-form-group>

            <b-form-group label="Customs and Handling">
              <b-form-input
                @forminput="form.customs_and_handling = null"
                v-model="form.customs_and_handling"
                type="number"
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Fumigation">
              <b-form-input v-model="form.fumigation" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Inspections">
              <b-form-input v-model="form.inspections" type="number"></b-form-input>
            </b-form-group>

            <b-form-group label="Quality Issues">
              <b-form-input v-model="form.quality_issues" type="number"></b-form-input>
            </b-form-group>

            <b-form-group label="Asoex">
              <b-form-input v-model="form.asoex" type="number"></b-form-input>
            </b-form-group>

            <b-form-group label="Freight">
              <b-form-input v-model="form.freigth" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Extra Costs">
              <b-form-input v-model="form.extra_costs" type="number"></b-form-input>
            </b-form-group>

            <b-form-group label="Other Costs">
              <b-form-input v-model="form.other_costs" type="number"></b-form-input>
            </b-form-group>

            <b-form-group label="Insurance">
              <b-form-input v-model="form.insurance" type="number"></b-form-input>
            </b-form-group>

            <b-form-group label="File">
              <b-form-file v-model="form.file"></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="border-top">
          <b-col class="text-right">
            <p>
              Total sales: <b>{{ getTotal | currency }}</b> <br />
              Total costs: <b>{{ getTotalCosts | currency }}</b> <br />
              <b>Total FOB: {{ getFob | currency }}</b>
            </p>
            <p class="text-right border-top">
              Total boxes: <b>{{ boxes.reduce((acc, item) => acc + parseFloat(item.total), 0) }}</b> <br />
              Total net kilograms: <b>{{ getNetKilograms | decimal }}</b> <br />
              Cost per kilogram: <b>{{ getCostPerKilogram | decimal }} USD/Kg</b>
            </p>
          </b-col>
        </b-row>
        <b-row class="border-top">
          <b-col class="text-right">
            <p>
              FOB per format: <br />
              <span v-for="container in boxes" :key="container.container_id">
                {{ container.container__name }}: <b>{{ getFobPerContainer(container) | currency }}</b> <br />
              </span>
            </p>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content title="Pagos">
        <template v-for="(payment, paymentIndex) in payments">
          <b-input-group class="mb-3" prepend="Monto" :key="paymentIndex">
            <b-form-input v-model="payments[paymentIndex]['amount']" type="number"></b-form-input>
            <b-input-group-append v-if="paymentIndex == payments.length - 1">
              <b-button size="sm" @click.prevent="newPayment" variant="outline-primary"
                ><i class="fa fa-plus"></i
              ></b-button>
            </b-input-group-append>
          </b-input-group>
        </template>
      </tab-content>
    </form-wizard>
  </b-modal>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
export default {
  name: "IngresarLiquidacion",
  components: {
    FormWizard,
    TabContent
  },
  filters: {
    decimal(value) {
      return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    },
    currency(value) {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);
    }
  },

  computed: {
    payload() {
      return {
        ...this.form,
        shipments: this.selectedShipments.join(","),
        boxes: this.boxes.map((item) => {
          return {
            container_id: item.container_id,
            price: item.price,
            fob: item.fob,
            cost_per_box: item.cost_per_kilogram * item.container__net_weight,
            total_quantity: item.total
          };
        }),
        payments: this.payments.map((item) => {
          return {
            amount: item.amount,
            payment_type: item.payment_type
          };
        })
      };
    },
    getTotal() {
      return this.boxes.reduce((acc, item) => acc + parseFloat(item.total) * parseFloat(item.price || 0), 0);
    },
    getTotalCosts() {
      const costs = [
        "commision",
        "customs_and_handling",
        "fumigation",
        "inspections",
        "quality_issues",
        "asoex",
        "freigth",
        "insurance",
        "extra_costs",
        "other_costs"
      ];
      return costs.reduce((acc, item) => acc + parseFloat(this.form[item] || 0), 0);
    },
    getCostPerKilogram() {
      const cpk = this.getTotalCosts / this.getNetKilograms;
      const roundedCpk = Math.round(cpk * 100) / 100;
      return roundedCpk;
    },
    getFob() {
      return parseFloat(this.getTotal) - parseFloat(this.getTotalCosts);
    },
    getNetKilograms() {
      const net = this.boxes.reduce((acc, item) => acc + parseFloat(item.total * item.container__net_weight), 0);
      const roundedNet = Math.round(net * 100) / 100;
      return roundedNet;
    }
  },
  watch: {
    form: {
      handler() {
        for (let i = 0; i < this.boxes.length; i++) {
          this.$set(this.boxes[i], "fob", this.getFobPerContainer(this.boxes[i]));
          this.$set(this.boxes[i], "cost_per_kilogram", this.getCostPerKilogram);
        }
      },
      deep: true
    }
  },
  methods: {
    newPayment() {
      this.payments.push({
        amount: null,
        payment_type: "liquidacion"
      });
    },
    getFobPerContainer(item) {
      const fob = this.getSubtotal(item) / item.total - this.getCostPerKilogram * item.container__net_weight;
      const roundedFob = Math.round(fob * 100) / 100;
      return roundedFob;
    },
    getSubtotal(item) {
      const subtotal = parseFloat(item.total) * parseFloat(item.price || 0);
      const roundedSubtotal = Math.round(subtotal * 100) / 100;
      return roundedSubtotal;
    },
    async onComplete() {
      this.loading = true;
      try {
        let formData = new FormData();
        formData.append("file", this.payload.file);

        // Append other properties of the payload to formData
        for (let key in this.payload) {
          if (key !== "file") {
            if (Array.isArray(this.payload[key]) || typeof this.payload[key] === "object") {
              // Convert arrays or objects to JSON string
              formData.append(key, JSON.stringify(this.payload[key]));
            } else {
              // Append other data as is
              formData.append(key, this.payload[key]);
            }
          }
        }
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        const res = await this.$axios.post("/api/comex/groweradvancesummary/", formData, config);
        this.$emit("on-complete", res.data);
        this.resetForm();
        this.$refs.wizard.reset();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchShipmentBoxes() {
      this.loading = true;
      let result = false;
      try {
        const params = {
          selected_shipments: this.selectedShipments.join(",")
        };
        const res = await this.$axios.get("/api/comex/shipment/boxes/", { params });
        this.boxes = res.data;
        result = true;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
      return result;
    },
    async fetchShipmentOptions() {
      this.loading = true;
      try {
        const res = await this.$axios.get("/api/comex/shipment/options/");
        this.shipmentOptions = res.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    onShow() {
      this.fetchShipmentOptions();
    },
    resetForm() {
      this.form = {
        date: null,
        commision: 0,
        customs_and_handling: 0,
        fumigation: 0,
        inspections: 0,
        quality_issues: 0,
        asoex: 0,
        freigth: 0,
        insurance: 0,
        extra_costs: 0,
        other_costs: 0,
        client: null,
        file: null
      };
      this.selectedShipments = [];
      this.boxes = [];
      this.payments = [
        {
          amount: null,
          payment_type: "liquidacion"
        }
      ];
    }
  },
  data() {
    return {
      loading: false,
      selectedShipments: [],
      shipmentOptions: [],
      boxes: [],
      fields: [
        "container__name",
        "container__sku",
        "total",
        {
          key: "price",
          label: "Price",
          class: "w-10"
        },
        {
          key: "subtotal",
          label: "Subtotal",
          class: "text-right"
        }
      ],
      form: {
        date: null,
        commision: 0,
        customs_and_handling: 0,
        fumigation: 0,
        inspections: 0,
        quality_issues: 0,
        asoex: 0,
        freigth: 0,
        insurance: 0,
        extra_costs: 0,
        other_costs: 0,
        file: null
      },
      payments: [
        {
          amount: null,
          payment_type: "liquidacion"
        }
      ]
    };
  }
};
</script>
<style></style>
